<script setup lang="ts">
import VModal from '@shared/component/VModal/VModal.vue';
import { useKlankbordVerzoek } from '../composables/useKlankbordVerzoek';

const {
  showKlankbordModal,
  klankbordLoading,
  klankbordResultaat,
  verstuurKlankbordVerzoek,
  openKlankbordModal,
  sluitKlankbordModal,
} = useKlankbordVerzoek();

function handleConfirmAction() {
  if (klankbordResultaat.value === 'idle') {
    verstuurKlankbordVerzoek();
  } else {
    sluitKlankbordModal();
  }
}
</script>

<template>
  <div class="col-span-full text-sm text-grey-500">
    Wil je eens klankborden met de directie omdat je een goed idee of een verbeterpunt hebt? Klik
    dan
    <a
      href="#"
      class="inline text-primary underline hover:text-primary-700"
      @click.prevent="openKlankbordModal"
    >
      hier
    </a>
    en Bart, Carl en/of Levent neemt contact met je op.
  </div>

  <VModal
    :is-active="showKlankbordModal"
    :title="klankbordResultaat === 'idle' ? 'Klankbord verzoek' : 'Verzoek ingediend'"
    :confirm-button-text="klankbordResultaat === 'idle' ? 'Versturen' : 'Sluiten'"
    :cancel-button-text="klankbordResultaat === 'idle' ? 'Annuleren' : ''"
    :loading="klankbordLoading"
    size="sm"
    @close="sluitKlankbordModal"
    @confirm-action="handleConfirmAction"
  >
    <template v-if="klankbordResultaat === 'idle'">
      <p>Klik op Versturen om je klankbord verzoek in te dienen.</p>
    </template>
    <template v-else-if="klankbordResultaat === 'succes'">
      <p class="font-medium">Je verzoek is in goede orde ontvangen.</p>
      <p class="mt-1">Bart, Carl en/of Levent neemt zo spoedig mogelijk contact met je op.</p>
    </template>
    <template v-else>
      <p>Er is helaas iets misgegaan. Probeer het later opnieuw.</p>
    </template>
  </VModal>
</template>
